import { useMutation } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest } from '../utils/graphqlClient';
import {
  profileQueryKeys,
  useProfileMutationFeedback,
} from './useProfileMutationFeedback';

const upsertDiveCertificationMutation = graphql(/* GraphQL */ `
  mutation upsertDiveCertification($input: DiveCertificateInput!) {
    upsertDiveCertification(input: $input)
  }
`);

export type DiveCertificateInput = {
  certificateId: number;
  userId: string;
  certificateLevel: string;
  certifyingAgency: string;
  certificateNumber: string;
};

const useUpsertDiveCertification = () => {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
  const userId = user?.sub ?? '';
  const feedback = useProfileMutationFeedback({
    successMessage: 'Dive certificate saved',
    queryKeys: [profileQueryKeys.diveCertificates(userId)],
  });

  return useMutation({
    mutationFn: async (input: DiveCertificateInput) => {
      if (!isAuthenticated) {
        throw new Error(
          'User must be authenticated to upsert dive certification',
        );
      }
      return graphqlRequest(
        upsertDiveCertificationMutation,
        { input },
        getAccessTokenSilently,
      );
    },
    ...feedback,
  });
};

export default useUpsertDiveCertification;
